var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-chart-container"},[_c('ECharts',{ref:"pieChart",attrs:{"option":_vm.chartOption,"width":_vm.width,"height":_vm.height,"autoresize":_vm.autoresize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }